import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RequestStatus } from '@atlassian/mpac-api-client';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { Stripe } from '@atlassian/mpac-primitives';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFlag as _addFlag } from '../../../actions/Flags';
import { getAppRequestedStatus } from '../../../services/AppRequests';
import { getCloudIdFromHostInfo } from '../../../services/HostInfoApi';
import getSPI from '../../../services/SPI';
import { AppRequestStatusTooltipV2 } from '../AppRequestStatusTooltip';
import AppRequestStatusTooltip from '../AppRequestStatusTooltip/AppRequestStatusTooltip';
import RequestApp from '../RequestApp';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RequestAppContainer(props) {
  const hostInfo = useSelector(state => state.configuration.hostInfo.fold(() => {
    /* hostInfo does not exist */
  }, hostInfoRes => hostInfoRes.fold(() => {
    /* getting hostInfo had errors */
  }, hi => hi)));
  const hostConfig = useSelector(state => state.configuration.hostConfig.fold(() => {
    /* hostConfig does not exist */
  }, hostConfigRes => hostConfigRes.fold(() => {
    /* getting hostConfig had errors */
  }, hc => hc)));
  const cloudId = getCloudIdFromHostInfo(hostInfo);
  const [isAppRequestStatusInProgress, setAppRequestStatusInProgress] = useState(true);
  const [appRequestStatusResponse, setAppRequestStatusResponse] = useState(null);
  const {
    enableAetherAppListingPage
  } = useStatsig();
  const dispatch = useDispatch();
  const showAetherAppListingPage = enableAetherAppListingPage();
  useEffect(() => {
    if (hostConfig) {
      getSPI().getCurrentUser().then(currentUser => {
        const {
          atlassianAccountId: userId
        } = currentUser;
        if (userId && cloudId && hostInfo) {
          getAppRequestedStatus({
            cloudId,
            productName: hostInfo.product,
            appKey: props.appKey,
            userId
          }).then(response => {
            setAppRequestStatusResponse(response);
          }).catch(error => {
            log.error('RequestAppContainer', "Failed to retrieve app requested status", {
              error
            });
          }).finally(_ => setAppRequestStatusInProgress(false));
        }
      }).catch(console.error.bind(console));
    }
  }, []);
  const onRequestSubmit = () => setAppRequestStatusResponse({
    status: RequestStatus.OPEN,
    requestedDate: new Date().toString()
  });
  if (!hostInfo || !hostConfig || !cloudId) {
    return 'Something went wrong';
  }
  if (isAppRequestStatusInProgress) {
    return showAetherAppListingPage ? /*#__PURE__*/_jsx(Stripe, {
      width: "6rem",
      height: "2rem",
      borderRadius: "var(--ds-border-radius-200)"
    }) : 'Loading...';
  }
  if (appRequestStatusResponse) {
    if (showAetherAppListingPage) {
      return /*#__PURE__*/_jsx(AppRequestStatusTooltipV2, {
        appRequestStatus: appRequestStatusResponse
      });
    }
    return /*#__PURE__*/_jsx(AppRequestStatusTooltip, {
      appRequestStatus: appRequestStatusResponse
    });
  }
  return /*#__PURE__*/_jsx(RequestApp, _objectSpread(_objectSpread({}, props), {}, {
    productName: hostInfo.product,
    cloudId: cloudId,
    addFlag: flag => dispatch(_addFlag({
      flag
    })),
    onRequestSubmit: onRequestSubmit
  }));
}